// extracted by mini-css-extract-plugin
export var leftAlign = "_redotech-arbiter-lib-tooltip-tooltip-left-align";
export var popper = "_redotech-arbiter-lib-tooltip-tooltip-popper";
export var subtitle = "_redotech-arbiter-lib-tooltip-tooltip-subtitle";